import { useEffect } from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import {
    ADOBE_TOPICS,
    COMMON_TAGGING_PROPERTIES,
    SgSessionStorageService,
    SgSubmissionUtil
} from 'saga-modules';
import { publish } from '@jutro/events';
import CommonConstants from 'sg-common-constants';
import { SG_AA_QUOTE_JOURNEY, SG_AA_QUOTE_TYPE, SG_AA_TRAFFIC_TYPE } from './AdobeAnalyticsConstants';
import SgProductService from '../sg-product-service';

function useSgAdobeAnalyticsForWizard(props) {
    const {
        modelVM
    } = props;

    const location = useLocation();

    function getLoggedInStatus() {
        // check for existance of ctic cookie
        return document.cookie.indexOf('; ctic=') > -1;
    }

    useEffect(() => {
        if (_.isNil(modelVM)) {
            return;
        }
        let quoteType = SG_AA_QUOTE_TYPE.QUOTE_STANDARD;
        let trafficType = SG_AA_TRAFFIC_TYPE.STANDARD;
        const isRetrieval = SgSessionStorageService.getItem(SgSessionStorageService.KEY.IS_RETRIEVAL_JOURNEY) || false;

        if (modelVM.aggregatorDetailsDTO_Ext && modelVM.aggregatorDetailsDTO_Ext.value
            && modelVM.aggregatorDetailsDTO_Ext.isAggregatorQuote_Ext.value) {
            const aggName = modelVM.aggregatorDetailsDTO_Ext.aggregatorName_Ext.value
                && modelVM.aggregatorDetailsDTO_Ext.aggregatorName_Ext.value.replace(/\s/g, '');
            trafficType = `${SG_AA_QUOTE_TYPE.QUOTE_AGGREGATOR}|${aggName}`;
            quoteType = isRetrieval ? SG_AA_QUOTE_TYPE.QUOTE_RETRIEVE : SG_AA_QUOTE_TYPE.QUOTE_AGGREGATOR;
            if (modelVM.aggregatorDetailsDTO_Ext.isAggregatorBestPrice_Ext.value) {
                quoteType = SG_AA_QUOTE_TYPE.QUOTE_RETRIEVE;
            }
        } else if (SgSubmissionUtil.isIndicativeQuote(modelVM)) {
            quoteType = SG_AA_QUOTE_TYPE.QUOTE_INDICATIVE;
        } else if (SgSubmissionUtil.isIndicativeToFullQuote(modelVM)) {
            quoteType = SG_AA_QUOTE_TYPE.QUOTE_FULL;
        } else if (SgSessionStorageService.getItem(SgSessionStorageService.KEY.IS_RETRIEVAL_JOURNEY)) {
            quoteType = SG_AA_QUOTE_TYPE.QUOTE_RETRIEVE;
        }
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.BHquoteType, value: quoteType });
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.BHtrafficType, value: trafficType });
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.loginStatus, value: getLoggedInStatus() });
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.productCategory, value: SgProductService.getProductCategory() });
    }, [modelVM]);

    useEffect(() => {
        const quoteJourney = modelVM && modelVM.baseData && modelVM.baseData.policyPeriodStatus_Ext
        && modelVM.baseData.policyPeriodStatus_Ext.value === CommonConstants.POLICY_PERIOD_STATUS.QUOTED
            ? SG_AA_QUOTE_JOURNEY.QUOTE_EDIT : SG_AA_QUOTE_JOURNEY.QUOTE_NON_EDIT;
        publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.BHquoteJourney, value: quoteJourney });
    }, [location]);

    return false;
}

export default useSgAdobeAnalyticsForWizard;
